export interface NotificationResponse {
  isSuccesful: boolean;
  error: any;
  count: number;
}
export enum TriggerEventId {
  WandaPlusSubscription = 417,
  WandaBasicSubscription = 418,
  BookingSummary = 419,
  BookingCancelled = 420,
  ServiceUserAdded = 421,
  SubscriptionRefund = 604,
  TripRefund = 606,
}

export enum EmailNotificationValues {
  PlanName = "Wanda Plus",
  ServiceType = "Ride",
}

export interface NotificationWandaPlus {
  eventId: number;
  personId: number;
  organizationId: number;
  caregiverName: string;
  subscriptionType: string;
  subscriptionDate: string;
  subscriptionPrice: string;
  transactionId: string;
  subscriptionUpgradeDate: string;
  subscriptionRenewalDate: string;
  wandaAppBaseUrl: string;
}

export interface NotificationTripBooking {
  eventId: number;
  personId: number;
  serviceUserPersonId: number;
  organizationId: number;
  caregiverName: string;
  serviceDate: string;
  sourceSystemId: number;
  serviceType: string;
  bookingId: string;
  customerServicePhone: string;
  services: NotificationTripBookingService[];
}

export interface NotificationTripBookingService {
  serviceId: string;
  pickupTime: string;
  pickupAddress: string;
  pickupInstructions: string;
  dropOffAddress: string;
  dropOffInstructions: string;
  tripRouteImageUrl: string;
}
export interface EmailTripBookingModel {
  eventId: number;
  careGiverPersonId: number;
  careGiverName: string;
  organizationId: number;
  serviceUserPersonId: number;
  requestAssignmentId: number;
  bookingId: string;
  tripDate: string;
  sourceSystemId: number;
}

export interface NotificationWandaBasic {
  eventId: number;
  personId: number;
  organizationId: number;
  caregiverName: string;
  serviceType: string;
  customerServicePhone: string; 
  subscriptionEndDate: string;
  services: NotificationWandaBasicService[] | null;
}

export interface NotificationWandaBasicService {
  serviceId: string;
  pickupTime: string;
  pickupAddress: string;
  pickupInstructions: string;
  dropOffAddress: string;
  dropOffInstructions: string;
  serviceUserPersonId: number;
  bookingId: string;
}

export interface NotificationServiceUserAdded {
  eventId: number;
  personId: number;
  organizationId: number;
  caregiverName: string;
  serviceUserPersonId: number;
  wandaAppBaseUrl: string;
  customerServicePhone: string;
}

export interface NotificationSubscriptionRefund {
  eventId: number;
  personId: number;
  organizationId: number;
  caregiverName: string;
  refundAmount: string;
  ccLast4Digits: string;
  subscriptionType: string;
  subscriptionDate: string;
  subscriptionPrice: string;
  transactionId: string;
  customerServicePhone: string;
}

export interface NotificationTripRefund {
  eventId: number;
  personId: number;
  serviceUserPersonId: number;
  organizationId: number;
  caregiverName: string;
  serviceDate: string;
  serviceType: string;
  customerServicePhone: string;
  ccLast4Digits: string;
  refundAmount: string;
  bookingId: string;
  services: { serviceId: string }[];
  sourceSystemId: number;
}
